module.exports = __webpack_public_path__ + "img/9788934974260.3e3a340f.jpg";